<script setup lang="ts">
withDefaults(defineProps<{ sticky?: boolean }>(), { sticky: true })
</script>
<template>
  <header
    class="ui-topbar"
    :class="{ 'ui-topbar--sticky': sticky }"
  >
    <slot
      ><div class="ui-topbar-start"><slot name="start" /></div>
      <div class="ui-topbar-center"><slot name="center" /></div>
      <div class="ui-topbar-end"><slot name="end" /></div
    ></slot>
  </header>
</template>
